export enum TrackType {
  CREATE_LOCAL_AUDIO_TRACK = 'CREATE_LOCAL_AUDIO_TRACK',
  CREATE_LOCAL_AUDIO_TRACK_ERROR = 'CREATE_LOCAL_AUDIO_TRACK_ERROR',
  CREATE_LOCAL_AUDIO_TRACK_SUCCESS = 'CREATE_LOCAL_AUDIO_TRACK_SUCCESS',
  CREATE_LOCAL_VIDEO_TRACK = 'CREATE_LOCAL_VIDEO_TRACK',
  CREATE_LOCAL_VIDEO_TRACK_ERROR = 'CREATE_LOCAL_VIDEO_TRACK_ERROR',
  CREATE_LOCAL_VIDEO_TRACK_SUCCESS = 'CREATE_LOCAL_VIDEO_TRACK_SUCCESS',
  CREATING_LOCAL_TRACKS = 'CREATING_LOCAL_TRACKS',
  CREATING_LOCAL_TRACKS_ERROR = 'CREATING_LOCAL_TRACKS_ERROR',
  CREATING_LOCAL_TRACKS_SUCCESS = 'CREATING_LOCAL_TRACKS_SUCCESS',
  SET_SELECTED_VIDEO_DEVICE = 'SET_SELECTED_VIDEO_DEVICE',
  SET_SELECTED_AUDIO_DEVICE = 'SET_SELECTED_AUDIO_DEVICE',
  SET_SCREENSHARE = 'SET_SCREENSHARE',
  UNSET_SCREENSHARE = 'UNSET_SCREENSHARE',
  SET_ENABLED_AUDIO_TRACK = 'SET_ENABLED_AUDIO_TRACK',
  REMOVE_ENABLED_AUDIO_TRACK = 'REMOVE_ENABLED_AUDIO_TRACK',
  SET_ENABLED_VIDEO_TRACK = 'SET_ENABLED_VIDEO_TRACK',
  REMOVE_ENABLED_VIDEO_TRACK = 'REMOVE_ENABLED_VIDEO_TRACK',
  SET_AUDIO_SOURCE = 'SET_AUDIO_SOURCE',
  SET_ENABLED_AUDIO_TRACKS = 'SET_ENABLED_AUDIO_TRACKS',
  SET_ENABLED_AUDIO_TRACKS_ERROR = 'SET_ENABLED_AUDIO_TRACKS_ERROR',
  SET_ENABLED_VIDEO_TRACKS = 'SET_ENABLED_VIDEO_TRACKS',
  SET_ENABLED_VIDEO_TRACKS_ERROR = 'SET_ENABLED_VIDEO_TRACKS_ERROR',
  TOGGLE_AUDIO_TRACK = 'TOGGLE_AUDIO_TRACK',
  TOGGLE_AUDIO_TRACK_SUCCESS = 'TOGGLE_AUDIO_TRACK_SUCCESS',
  TOGGLE_AUDIO_TRACK_ERROR = 'TOGGLE_AUDIO_TRACK_ERROR',
  TOGGLE_VIDEO_TRACK = 'TOGGLE_VIDEO_TRACK',
  TOGGLE_VIDEO_TRACK_SUCCESS = 'TOGGLE_VIDEO_TRACK_SUCCESS',
  TOGGLE_VIDEO_TRACK_ERROR = 'TOGGLE_VIDEO_TRACK_ERROR',
  REMOVE_LOCAL_AUDIO_TRACK_FOR_DIAL_IN = 'REMOVE_LOCAL_AUDIO_TRACK_FOR_DIAL_IN',
  REMOVE_LOCAL_AUDIO_TRACK_FOR_DIAL_IN_ERROR = '  REMOVE_LOCAL_AUDIO_TRACK_FOR_DIAL_IN_ERROR',
  REMOVE_LOCAL_AUDIO_TRACK_FOR_DIAL_IN_SUCCESS = '  REMOVE_LOCAL_AUDIO_TRACK_FOR_DIAL_IN_SUCCESS',
  VIDEO_QUALITY_CHANGE_ERROR = 'VIDEO_QUALITY_CHANGE_ERROR',
  VIDEO_QUALITY_CHANGE_SUCCESS = 'VIDEO_QUALITY_CHANGE_SUCCESS',
  LOCAL_PARTICIPANT_MUTED = 'LOCAL_PARTICIPANT_MUTED',
  LOCAL_PARTICIPANT_UNMUTED = 'LOCAL_PARTICIPANT_UNMUTED',
  SET_BACKGROUND_ERROR = "SET_BACKGROUND_ERROR",
  SET_BACKGROUND_SUCCESS = "SET_BACKGROUND_SUCCESS",
  FORCE_LOCAL_MUTE = 'FORCE_LOCAL_MUTE',
  FORCE_LOCAL_MUTE_DISABLE = 'FORCE_LOCAL_MUTE_DISABLE'
}
